import { useMsal } from "@azure/msal-react";
import React, { useState } from 'react';
import { ComponentsHelper } from "../../core/services/ComponentHelper";

export interface IMyAccountPageProps {
    isCRMIntegrationEnabled: boolean;
    powerPortalURL: string;
    currentUserGuid: string;
    currentUserNameNumber: string;
    getUserCRMValues: () => void;

}

const MyAccountPage = (props: IMyAccountPageProps) => {
    const { instance, accounts } = useMsal();
    const langMap: Record<string, string> = { "en-GB": "en-US", "fr": "fr-FR" };
    let storedPreferences = JSON.parse(localStorage.getItem('userLanguagePreferences') || '"en-US"');
    storedPreferences = langMap[storedPreferences] || storedPreferences;
    
    React.useEffect(() => {
    const account = accounts[0]
    ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [])

    if (!props.currentUserGuid) {
        props.getUserCRMValues();
    }

    let accountPage = <div></div>;
    
    if (props.isCRMIntegrationEnabled) {
        accountPage = <iframe src={`${props.powerPortalURL + "/" + storedPreferences + "/account-management/?id=" + props.currentUserGuid + "&lang=" + storedPreferences}`} style={{ width: '100%', height: '100vh' }} ></iframe>
    }

    return (
        accountPage      
    );
}

export default MyAccountPage;